module.exports = __webpack_public_path__ + "static/media/GUIDE_0009_02.0ed342a5.webp";